import { IBrandingSettingsSagaContext } from '../branding-settings-saga';

export function* handleClickedSaga(context: IBrandingSettingsSagaContext): IterableIterator<any> {
	console.log(context);
	console.log('Clicked, yo!');
	yield 'clicked done!';
	return;
}
